import { key as keyEnv, iv as ivEnv } from '@amwager/util-ts'



const ENCRYPTION_ERROR = 'Encryption Error!';

// convert ArrayBuffer to hex string for easy reading
const BUFFER_TO_HEX = (buffer: ArrayBuffer): string | null => {
	try {
    return Array.from(new Uint8Array(buffer))
		  .map(b => b.toString(16).padStart(2, '0'))
		  .join('');
  }
  catch (error) {
    console.error(ENCRYPTION_ERROR + ' BUFFER_TO_HEX', error);
    return null;
  }
}

// convert hex String to ArrayBuffer
const HEX_TO_BUFFER = (hex: string): ArrayBuffer | null => {
  try {
    if (hex.length % 2 !== 0) {
      throw new Error('Invalid hex string');
    }

    const buffer = new Uint8Array(hex.length / 2);

    for (let i = 0; i < hex.length; i += 2) {
      buffer[i / 2] = parseInt(hex.substring(i, i + 2), 16);

      // buffer[i / 2] = parseInt(hex.substring(i, 2), 16);
      // note: need 2 on the node with global
    }

    return buffer.buffer;
  }
  catch (error) {
    console.error(ENCRYPTION_ERROR + ' HEX_TO_BUFFER', error);
    return null;
  }
}

// import key
const IMPORT_AES_KEY = async (exportKey: ArrayBuffer): Promise<CryptoKey> => {
	try {
    return await window.crypto.subtle.importKey(
	    "raw", // import from raw format
	    exportKey, // the exported key as an ArrayBuffer
	    {
	      name: "AES-GCM"
	    },
	    true, // the key can be extracted again
	    ["encrypt", "decrypt"] // key usages
  	);
  }
  catch (error) {
    console.error(ENCRYPTION_ERROR + ' IMPORT_AES_KEY', error);
    return {} as CryptoKey;
  }
};

// decrypt data
const DECRYPT_DATA = async (key: CryptoKey, iv: ArrayBuffer, encryptedData: ArrayBuffer)
: Promise<string | null> => {
  // console.log('DECRYPT_DATA:key', key);
  // console.log('DECRYPT_DATA:iv', iv);
  // console.log('DECRYPT_DATA:encryptedData', encryptedData);

  try {
    const decryptedData = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv // The same IV used during encryption
      },
      key, // The CryptoKey object
      encryptedData // The encrypted ArrayBuffer
    );
    return new TextDecoder().decode(decryptedData); // Convert decrypted data back to a string
  }
  catch (error) {
    console.error(ENCRYPTION_ERROR + ' DECRYPT_DATA', error);
    return null;
  }
};


export const TO_DECRYPT = async <T extends string> (
  data: T,
  key: T = keyEnv as T,
  iv: T = ivEnv as T
): Promise<T> => {

  if (!data || !key || !iv) return '' as unknown as Promise<T>;

  // console.log('TO_DECRYPT:data', data);
  // console.log('TO_DECRYPT:key', key);
  // console.log('TO_DECRYPT:iv', iv);

  const keyBuffer = HEX_TO_BUFFER(key) as ArrayBuffer;
  const dataBuffer = HEX_TO_BUFFER(data) as ArrayBuffer;
  const ivBuffer = HEX_TO_BUFFER(iv) as ArrayBuffer;

  // console.log('TO_DECRYPT:data', dataBuffer);
  // console.log('TO_DECRYPT:key', keyBuffer);
  // console.log('TO_DECRYPT:iv', ivBuffer);

  // console.log('TO_DECRYPT:data', BUFFER_TO_HEX(dataBuffer));
  // console.log('TO_DECRYPT:key', BUFFER_TO_HEX(keyBuffer));
  // console.log('TO_DECRYPT:iv', BUFFER_TO_HEX(ivBuffer));

  const importedKey = await IMPORT_AES_KEY(keyBuffer);

  const decryptedData = await DECRYPT_DATA(importedKey, ivBuffer, dataBuffer);

	// console.log('Decrypted Data:', decryptedData);

  return decryptedData as unknown as Promise<T>;
}
